import { round } from 'Root/helpers/tools';

let defaultInfoEmitted = false;
let tagsQueue = [];

export default class {
  /* eslint-disable no-nested-ternary */
  static deviceType = typeof window !== 'undefined'
    ? /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd'
    : null;
  /* eslint-enable no-nested-ternary */

  static init() {
    window.criteo_q = window.criteo_q || [];
  }

  static invokeEvent(email) {
    // eslint-disable-next-line no-unreachable
    if (typeof window === 'undefined' || !process.env.CRITEO_ACCOUNT_ID) {
      return false;
    }

    if (!window.criteo_q) {
      this.init();
    }

    this.fireEmail(email);

    window.criteo_q.push(tagsQueue);
    tagsQueue = [];
    return true;
  }

  /**
   * @param {object} tag
   */
  static addToQueue(tag) {
    tagsQueue.push(tag);
  }

  /**
   * @param {string} email
   */
  static fireEmail(email) {
    if (email) {
      this.addToQueue({ event: 'setEmail', email });
    }
  }

  static fireDefaultInfo() {
    if (defaultInfoEmitted) {
      return null;
    }

    this.addToQueue({ event: 'setAccount', account: process.env.CRITEO_ACCOUNT_ID });
    this.addToQueue({ event: 'setSiteType', type: this.deviceType });

    defaultInfoEmitted = true;

    return true;
  }

  /**
   * @param {string} email
   */
  static fireMainPageVisit(email) {
    this.fireDefaultInfo();

    this.addToQueue({ event: 'viewHome' });

    return this.invokeEvent(email);
  }

  /**
   * @param {string} email
   */
  static firePageVisit(email) {
    this.fireDefaultInfo();

    this.addToQueue({ event: 'viewPage' });

    return this.invokeEvent(email);
  }

  /**
   * @param {string} email
   * @param {number} productId
   */
  static fireProductPageVisit(email, productId) {
    this.fireDefaultInfo();

    this.addToQueue({ event: 'viewItem', item: productId });

    return this.invokeEvent(email);
  }

  /**
   * @param {string} email
   * @param {object} order
   */
  static fireConversionEvent(email, order) {
    this.fireDefaultInfo();

    const offerId = order.product?.id || 'Custom order';
    const runs = order.runs || 1;

    this.addToQueue({
      event: 'trackTransaction',
      id: order.id,
      item: [{
        id: offerId,
        price: round(order.sum_in_usd / runs),
        quantity: runs,
      }],
    });

    return this.invokeEvent(email);
  }

  /**
   * @param {string} email
   * @param {int} id
   * @param {float} price
   * @param {int} runs
   */
  static fireAddToCartEvent(email, id, price, runs = 1) {
    this.fireDefaultInfo();

    const offerId = id || 'Custom order';

    this.addToQueue({
      event: 'addToCart',
      id,
      item: [{
        id: offerId,
        price: round(price / runs),
        quantity: runs,
      }],
    });

    return this.invokeEvent(email);
  }

  /**
   * @param {string} email
   * @param {object} activeTag
   * @param {object} items
   */
  static fireListingEvent(email, activeTag, items) {
    if (items.length === 0 || typeof activeTag?.id === 'undefined') {
      return false;
    }

    if (items.length > 3) {
      items.length = 3;
    }

    this.fireDefaultInfo();

    this.addToQueue({
      event: 'viewList',
      item: items,
      category: activeTag?.id,
    });

    return this.invokeEvent(email);
  }
}
